import type { SVGProps } from "react";

export default function DangerIcon(props: Readonly<SVGProps<SVGSVGElement>>) {
  return (
    <svg
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M3.54081 7.17409C5.48639 3.72453 6.45917 1.99976 7.99967 1.99976C9.54014 1.99976 10.5129 3.72453 12.4585 7.17409L12.7009 7.60396C14.3177 10.4705 15.1261 11.9038 14.3955 12.9518C13.6649 13.9998 11.8573 13.9998 8.24214 13.9998H7.75721C4.14205 13.9998 2.33445 13.9998 1.60385 12.9518C0.873234 11.9038 1.68161 10.4705 3.29837 7.60396L3.54081 7.17409Z"
        stroke="currentColor"
        strokeWidth="1.00422"
      />
      <path
        d="M7.99951 5.33362V8.66695"
        stroke="currentColor"
        strokeWidth="1.00422"
        strokeLinecap="round"
      />
      <path
        d="M7.99967 11.3335C8.36786 11.3335 8.66634 11.035 8.66634 10.6668C8.66634 10.2986 8.36786 10.0001 7.99967 10.0001C7.63148 10.0001 7.33301 10.2986 7.33301 10.6668C7.33301 11.035 7.63148 11.3335 7.99967 11.3335Z"
        fill="currentColor"
      />
    </svg>
  );
}
